/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import { BodyText } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import './CalculatorCardSubHeading.scss';
import { CalculatorResult } from '../../../modules/calculator/calculatorTypes';

interface CalculatorCardSubHeadingProps {
  config: any;
  currentResult?: CalculatorResult;
  cardIndex: number;
  variant?: string;
}

const CalculatorCardSubHeading = ({ config, cardIndex, variant, currentResult }: CalculatorCardSubHeadingProps) => {
  const { t } = useTranslation();
  const [toggleOn, setToggleOn] = React.useState<boolean>(false);

  React.useEffect(() => {
    const result: any = currentResult?.calculatorData?.cards[cardIndex];
    let bool = false;
    Object.keys({ ...result }).forEach((key) => {
      const value = result[key];
      if (value === true) {
        bool = true;
      }
    });
    if (bool) {
      setToggleOn(true);
    } else {
      setToggleOn(false);
    }
    if (variant === 'graph') {
      setToggleOn(false);
    }
  }, [config, cardIndex, currentResult, variant]);

  return (
    <div className={`calculator-card-sub-heading ${config?.advanced === true ? (toggleOn ? 'toggle-on' : 'toggle-off') : ''}`}>
      <BodyText>{t(config?.labelKey).toUpperCase()}</BodyText>
    </div>
  );
};

export default CalculatorCardSubHeading;
